import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getSubdomainAvailability = async (subdomain) => {
  if(!subdomain || subdomain.length<5){
    return false
  }
  const apiURL = API_HOST + ('/subdomains/check?subdomain='+subdomain);
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL,{
      headers: {
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
